export const SWITCH_TO_RESOURCE = 'SWITCH_TO_RESOURCE';
export const RESET_SWITCH_RESOURCE = 'RESET_SWITCH_RESOURCE';



// WEBPACK FOOTER //
// ./src/client/redux/redux-resource-plugins/switch/types.js